const ItalicIcon = ({ isActive }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1264_20697"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="17"
      >
        <rect x="0.5" y="0.973877" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1264_20697)">
        <path
          d="M3.83325 13.6405V11.9739H6.49992L8.49992 5.97388H5.83325V4.30721H12.4999V5.97388H10.1666L8.16659 11.9739H10.4999V13.6405H3.83325Z"
          fill={isActive ? '#00cf83' : '#89D3B8'}
        />
      </g>
    </svg>
  )
}

export default ItalicIcon
